import React, { useEffect, useRef, useState } from 'react';
import { SpinnerSC } from 'pages/style/spinner/spinner-styled';
import { TitleGroupComponent } from '../../../components/title/title-group-component';
import { Button, Col, Row, Form, Modal, Card, CardBody } from 'react-bootstrap';
import SelectCompany from '../../../components/filter/select-company-component';
import { RestUseCase } from 'service/api/rest/rest-usecase';
import { getEnv } from 'helper/window-helper';
import JoditEditor from 'jodit-react';
import ReactTooltip from 'react-tooltip';
import { TableHeaderFixedStyled } from 'pages/style/table/table-header-fixed-styled';
import { UseAlert } from 'hook/alert-hook';
import { FiltersDefault } from '../../../@types/interfaces/filter-interface';
import ContainerFilter from 'components/container/container-filter-component';
import { getLocalStorage, updateLocalStorege } from 'data/cache/localstorage-cache';
import { FaRegTrashAlt } from 'react-icons/fa';
import { ModalConfirmAction } from 'components/modal/modal-confirm-action-component';
import Select from 'react-select';
import { SelectOptionInterface } from '../../../@types/entity/interface/select-option-interface';
import { SingleValue } from 'react-select';

type Props = {
  titlePage: string;
  optionsFiltersDefault: FiltersDefault[];
  listByIdPlanning: (params?: any) => Promise<any>;
  listAllPlanning: (params?: any) => Promise<any>;
  createPlanning: (params?: any) => Promise<any>;
  editPlanning: (params?: any) => Promise<any>;
  removePlanning: (params?: any) => Promise<any>;
  onSelectedCompanyChange?: (companyId: string | null) => void;
};

const RegraConsultorOnlinePage: React.FC<Props> = ({ titlePage, optionsFiltersDefault, listAllPlanning, createPlanning, editPlanning, removePlanning, onSelectedCompanyChange }) => {
  interface MessageModel {
    id: number;
    nome: string;
    mensagem: string;
  }

  interface ConsultorOnlineTab {
    id: number;
    idAnalise: number;
    intervaloDiasExecucao: number;
    intervaloExecucao: number;
    mensagem: string;
    emails: string;
    nome: string;
    percentualMinimoEstoqueCustoMedio: number;
    percentualMinimoEstoqueReposicao: number;
    quantidadeDiasUltimaCarga: number;
    quantidadeMinimaItens: number;
    ultimaExecucao: number;
    valorMinimoCustoMedio: number;
    valorMinimoReposicao: number;
    dataAlteracao: string;
  }

  const [showModal, setShowModal] = useState(false);
  const [statusCrud, setStatusCrud] = useState('post'); //post, patch, delete
  const [loading, updateLoading] = useState<boolean>(false);
  const [selectedCompanyId, setSelectedCompanyId] = useState<string | null>(null);
  const [selectedUser, setSelectedUser] = useState<SelectOptionInterface | null>(null);
  const [usersList, setUsersList] = useState<any[]>([]);
  const [nome, setNome] = useState('');
  const [emails, setEmails] = useState('');
  const [intervaloDias, setIntervaloDias] = useState<number | 0>(0);
  const [quantidadeDiasUltimaCarga, setQuantidadeDiasUltimaCarga] = useState<number | 0>(0);
  const [percentualMinimoEstoqueCustoMedio, setPercentualMinimoEstoqueCustoMedio] = useState<number | 0>(0);
  const [percentualMinimoEstoqueReposicao, setPercentualMinimoEstoqueReposicao] = useState<number | 0>(0);
  const [valorMinimoCustoMedio, setValorMinimoCustoMedio] = useState<number | 0>(0);
  const [valorMinimoReposicao, setValorMinimoReposicao] = useState<number | 0>(0);
  const [quantidadeMinimaItens, setQuantidadeMinimaItens] = useState<number | 0>(0);
  const [idAnalise, setIdAnalise] = useState<number | 0>(0);
  const [analise, setAnalise] = useState<SelectOptionInterface | null>(null);
  const [filterData, setFilterData] = useState<any[]>([]);
  const [messageModelActive, setMessageModelActive] = useState<MessageModel[]>([]);
  const [messageModelInactive, setMessageModelInactive] = useState<MessageModel[]>([]);
  const [selectedCOId, setSelectedCOId] = useState<number | 0>(0);
  const [selectedCOName, setSelectedCOName] = useState<string>();
  const [message, setMessage] = useState('');
  const [selectedMessage, setSelectedMessage] = useState<SelectOptionInterface | null>(null);
  const [tabBodyConsultantActive, setTabBodyConsultantActive] = useState<React.ReactNode>(
    <div className="d-flex align-items-center justify-content-center" style={{ backgroundColor: '#fff', margin: '10px 15px 10px 15px' }}>
      Não existem consultores online ativos.
    </div>
  );
  const [tabBodyConsultantInactive, setTabBodyConsultantInactive] = useState<React.ReactNode>(
    <div className="d-flex align-items-center justify-content-center" style={{ backgroundColor: '#fff', margin: '10px 15px 10px 15px' }}>
      Não existem consultores online inativos.
    </div>
  );
  const [isConsultantInactive, setIsConsultantInactive] = useState(false);
  const [showConsultantActivation, setShowConsultantActivation] = useState(false);

  const [showModalConfirmDeletarCO, updateShowModalConfirmDeletarCO] = useState(false);
  const openModalConfirmDeletarCO = () => updateShowModalConfirmDeletarCO(true);
  const closeModalConfirmDeletarCO = () => updateShowModalConfirmDeletarCO(false);

  const [showModalEnviarEmail, updateShowModalEnviarEmail] = useState(false);
  const openModalEnviarEmail = () => updateShowModalEnviarEmail(true);
  const closeModalEnviarEmail = () => updateShowModalEnviarEmail(false);

  const ENDPOINT_ANALYTICAL = getEnv('REACT_APP_END_POINT_ANALYTICAL')!;
  const ENDPOINT_CRUD = getEnv('REACT_APP_END_POINT_ONLINE_CONSULTANT')!;
  const LOCALSTORAGE_PLANNING = getEnv('REACT_APP_LOCALSTORAGE_PLANNING_ONLINE_CONSULTANT')!;
  const ENDPOINT_PLANNING = getEnv('REACT_APP_END_POINT_ONLINE_CONSULTANT') + '/filtros-empresa';

  const editorRef = useRef<any>(null);

  const variablesList: { value: string }[] = [
    { value: '{nome_empresa}' },
    { value: '{nome_usuario}' },
    { value: '{qtd_itens}' },
    { value: '{dt_ultpedido}' },
    { value: '{dt_ultcarga}' },
    { value: '{lista_itens}' },
    { value: '{vlr_itens_pedido}' },
    { value: '{vlr_itens_cstmed}' },
    { value: '{vlr_estoque_total_rep}' },
    { value: '{vlr_estoque_total_cstmed}' },
    { value: '{vlr_perc_itens_estoque_rep}' },
    { value: '{vlr_perc_itens_estoque_cstmed}' },
  ];

  const { showAlert } = UseAlert();

  function Loading() {
    return (
      <SpinnerSC>
        <div className="spinner-border text-secondary" role="status"></div>
      </SpinnerSC>
    );
  }

  const handleUserSelection = (user: SingleValue<SelectOptionInterface>) => {
    setSelectedUser(user);
  };

  const getUsersByCompany = async (companyId: string) => {
    try {
      let query = `?empresa=${companyId}`;
      query += `&roles=COMPRAS_GESTOR,COMPRAS_OPERACIONAL`;
      const response = await new RestUseCase(`${getEnv('REACT_APP_END_POINT_USER')}${query}`).Get();
      if (response.statusCode !== 500 && response.statusCode !== undefined) {
        setUsersList(
          response.body.map((user: any) => ({
            value: user.id,
            label: user.nome,
          }))
        );
      }
    } catch (error) {
      console.error('Erro ao buscar usuários:', error);
    }
  };

  const getFilterAnalyticalByCompany = async () => {
    try {
      if (selectedCompanyId !== null && selectedCompanyId !== undefined){
        const response = await new RestUseCase(`${ENDPOINT_PLANNING}/${selectedCompanyId}`).Get();

        // Mapeie os dados para o formato desejado antes de definir o estado
        setFilterData(
          response.body.map((item: any) => ({
            value: item.id,
            label: item.nome,
          }))
        );
      } 
    } catch (error) {
      console.error('Erro ao buscar os dados analíticos:', error);
    }
  };

  const handleChangeMessage = (event: any) => {
    setMessage(event);
  };

  const handleChangeModelo = (modelo: SingleValue<SelectOptionInterface>) => {
    let selectedValue = 0;
    let messageModelList = messageModelActive.concat(messageModelInactive);

    if (modelo?.value != null) selectedValue = parseInt(modelo.value, 10);

    const selectedItem = messageModelList.find((item) => item.id === selectedValue);
    setMessage(selectedItem?.mensagem ?? '');
    setSelectedMessage(modelo);
  };

  const handleChangeAnalise = (selectedPlanejamento: SingleValue<SelectOptionInterface>) => {
    if (selectedPlanejamento != null) {
      setAnalise(selectedPlanejamento);
      setIdAnalise(selectedPlanejamento.value);
    }
  };

  const handleChangeNome = (event: any) => {
    setNome(event.target.value);
  };

  const handleChangeEmails = (event: any) => {
    setEmails(event.target.value);
  };

  const handleChangeIntervaloDias = (event: any) => {
    setIntervaloDias(parseInt(event.target.value));
  };

  const handleChangeQuantidadeDiasUltimaCarga = (event: any) => {
    setQuantidadeDiasUltimaCarga(parseInt(event.target.value));
  };

  const handleChangePercentualMinimoEstoqueCustoMedio = (event: any) => {
    setPercentualMinimoEstoqueCustoMedio(parseInt(event.target.value));
  };

  const handleChangePercentualMinimoEstoqueReposicao = (event: any) => {
    setPercentualMinimoEstoqueReposicao(parseInt(event.target.value));
  };

  const handleChangeValorMinimoCustoMedio = (event: any) => {
    setValorMinimoCustoMedio(parseInt(event.target.value));
  };

  const handleChangeValorMinimoReposicao = (event: any) => {
    setValorMinimoReposicao(parseInt(event.target.value));
  };

  const handleChangeQuantidadeMinimaItens = (event: any) => {
    setQuantidadeMinimaItens(parseInt(event.target.value));
  };

  function findConsultantoOnline(idEmpresa: any) {
    getAll(idEmpresa);
    getAllInactive(idEmpresa);
  }

  const getAll = async (idEmpresa: any) => {
    try {
      const response = await new RestUseCase(`${ENDPOINT_CRUD}?idEmpresa=${idEmpresa}&page=0&size=50`).Get();

      if (response.statusCode !== 500 && response.statusCode !== undefined) {
        let planejamento = response.body.map((value: any) => {
          return { id: value.id, nome: value.nome, mensagem: value.mensagem };
        });
        setMessageModelActive(planejamento);
      }

      if (response.body) {
        const listConsultorOnline: ConsultorOnlineTab[] = response.body.map((value: ConsultorOnlineTab) => {
          return {
            id: value.id,
            idAnalise: value.idAnalise,
            intervaloDiasExecucao: value.intervaloDiasExecucao,
            intervaloExecucao: value.intervaloExecucao,
            mensagem: value.mensagem,
            emails: value.emails,
            nome: value.nome,
            percentualMinimoEstoqueCustoMedio: value.percentualMinimoEstoqueCustoMedio,
            percentualMinimoEstoqueReposicao: value.percentualMinimoEstoqueReposicao,
            quantidadeDiasUltimaCarga: value.quantidadeDiasUltimaCarga,
            quantidadeMinimaItens: value.quantidadeMinimaItens,
            ultimaExecucao: value.ultimaExecucao,
            valorMinimoCustoMedio: value.valorMinimoCustoMedio,
            valorMinimoReposicao: value.valorMinimoReposicao,
            dataAlteracao: value.dataAlteracao,
          };
        });

        if (listConsultorOnline.length > 0) {
          const tableRows = listConsultorOnline.map((item: any) => (
            <tr key={item.id} onClick={() => handleRowClick(item, false)} style={{ height: '10px' }}>
              <td style={{ textAlign: 'center' }}>
                <Button
                  className="me-1"
                  variant="danger"
                  size="sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedCOId(item.id);
                    setSelectedCOName(item.nome);
                    openModalConfirmDeletarCO();
                  }}
                >
                  <FaRegTrashAlt />
                </Button>
              </td>
              <td>{item.nome}</td>
              <td>{new Date(item.dataAlteracao).toLocaleDateString()}</td>
              <td>{item.ultimaExecucao}</td>
              <td>{item.intervaloDiasExecucao}</td>
              <td>{item.percentualMinimoEstoqueCustoMedio}</td>
              <td>{item.percentualMinimoEstoqueReposicao}</td>
              <td>{item.quantidadeDiasUltimaCarga}</td>
              <td>{item.quantidadeMinimaItens}</td>
              <td>{item.valorMinimoCustoMedio}</td>
              <td>{item.valorMinimoReposicao}</td>
            </tr>
          ));

          // Definir o HTML da tabela em setTabBody
          setTabBodyConsultantActive(
            <div style={{ backgroundColor: '#fff', margin: '10px 15px 10px 15px' }}>
              <TableHeaderFixedStyled style={{ height: '300px' }}>
                <table className="table table-hover" style={{ margin: '0' }}>
                  <thead>
                    <tr>
                      <th>Deletar</th>
                      <th>Nome</th>
                      <th>Data Alteração</th>
                      <th>Última Execução</th>
                      <th>Intervalo Dias Execução</th>
                      <th>Percentual Min. Estoque Custo Médio</th>
                      <th>Percentual Min. Estoque Reposição</th>
                      <th>Qtde. de Dias da Últia Carga</th>
                      <th>Qtde. Mínima de Itens</th>
                      <th>Valor Min. Custo Médio</th>
                      <th>Valor Min. Reposição</th>
                    </tr>
                  </thead>
                  <tbody>{tableRows}</tbody>
                </table>
              </TableHeaderFixedStyled>
            </div>
          );
        } else {
          setTabBodyConsultantActive(
            <div className="d-flex align-items-center justify-content-center" style={{ backgroundColor: '#fff', margin: '10px 15px 10px 15px' }}>
              <span>Não existem consultores online ativos.</span>
            </div>
          );
        }
      }
    } catch (error) {
      console.error('Erro ao buscar os dados:', error);
    }
  };

  const getAllInactive = async (idEmpresa: any) => {
    try {
      const response = await new RestUseCase(`${ENDPOINT_CRUD}/inativos?idEmpresa=${idEmpresa}&page=0&size=50`).Get();

      if (response.statusCode !== 500 && response.statusCode !== undefined) {
        let planejamento = response.body.map((value: any) => {
          return { id: value.id, nome: value.nome, mensagem: value.mensagem };
        });
        setMessageModelInactive(planejamento);
      }

      if (response.body) {
        const listConsultorOnline: ConsultorOnlineTab[] = response.body.map((value: ConsultorOnlineTab) => {
          return {
            id: value.id,
            idAnalise: value.idAnalise,
            intervaloDiasExecucao: value.intervaloDiasExecucao,
            intervaloExecucao: value.intervaloExecucao,
            mensagem: value.mensagem,
            emails: value.emails,
            nome: value.nome,
            percentualMinimoEstoqueCustoMedio: value.percentualMinimoEstoqueCustoMedio,
            percentualMinimoEstoqueReposicao: value.percentualMinimoEstoqueReposicao,
            quantidadeDiasUltimaCarga: value.quantidadeDiasUltimaCarga,
            quantidadeMinimaItens: value.quantidadeMinimaItens,
            ultimaExecucao: value.ultimaExecucao,
            valorMinimoCustoMedio: value.valorMinimoCustoMedio,
            valorMinimoReposicao: value.valorMinimoReposicao,
            dataAlteracao: value.dataAlteracao,
          };
        });

        if (listConsultorOnline.length > 0) {
          const tableRows = listConsultorOnline.map((item: any) => (
            <tr key={item.id} onClick={() => handleRowClick(item, true)} style={{ height: '10px' }}>
              <td style={{ textAlign: 'center' }}>
                <Button
                  className="me-1"
                  variant="danger"
                  size="sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedCOId(item.id);
                    setSelectedCOName(item.nome);
                    openModalConfirmDeletarCO();
                  }}
                >
                  <FaRegTrashAlt />
                </Button>
              </td>
              <td>{item.nome}</td>
              <td>{new Date(item.dataAlteracao).toLocaleDateString()}</td>
              <td>{item.ultimaExecucao}</td>
              <td>{item.intervaloDiasExecucao}</td>
              <td>{item.percentualMinimoEstoqueCustoMedio}</td>
              <td>{item.percentualMinimoEstoqueReposicao}</td>
              <td>{item.quantidadeDiasUltimaCarga}</td>
              <td>{item.quantidadeMinimaItens}</td>
              <td>{item.valorMinimoCustoMedio}</td>
              <td>{item.valorMinimoReposicao}</td>
            </tr>
          ));

          // Definir o HTML da tabela em setTabBody
          setTabBodyConsultantInactive(
            <div style={{ backgroundColor: '#fff', margin: '10px 15px 10px 15px' }}>
              <TableHeaderFixedStyled style={{ height: '300px' }}>
                <table className="table table-hover" style={{ margin: '0' }}>
                  <thead>
                    <tr>
                      <th>Deletar</th>
                      <th>Nome</th>
                      <th>Data Alteração</th>
                      <th>Última Execução</th>
                      <th>Intervalo Dias Execução</th>
                      <th>Percentual Min. Estoque Custo Médio</th>
                      <th>Percentual Min. Estoque Reposição</th>
                      <th>Qtde. de Dias da Últia Carga</th>
                      <th>Qtde. Mínima de Itens</th>
                      <th>Valor Min. Custo Médio</th>
                      <th>Valor Min. Reposição</th>
                    </tr>
                  </thead>
                  <tbody>{tableRows}</tbody>
                </table>
              </TableHeaderFixedStyled>
            </div>
          );
        } else {
          setTabBodyConsultantInactive(
            <div className="d-flex align-items-center justify-content-center" style={{ backgroundColor: '#fff', margin: '10px 15px 10px 15px' }}>
              <span>Não existem consultores online inativos.</span>
            </div>
          );
        }
      }
    } catch (error) {
      console.error('Erro ao buscar os dados:', error);
    }
  };

  const handleRowClick = (selectedItem: ConsultorOnlineTab, active: boolean) => {
    if (selectedItem) {
      setIsConsultantInactive(active);
      setShowConsultantActivation(true);
      setNome(selectedItem.nome);
      setIntervaloDias(selectedItem.intervaloDiasExecucao);
      setQuantidadeDiasUltimaCarga(selectedItem.quantidadeDiasUltimaCarga);
      setPercentualMinimoEstoqueCustoMedio(selectedItem.percentualMinimoEstoqueCustoMedio);
      setPercentualMinimoEstoqueReposicao(selectedItem.percentualMinimoEstoqueReposicao);
      setValorMinimoCustoMedio(selectedItem.valorMinimoCustoMedio);
      setValorMinimoReposicao(selectedItem.valorMinimoReposicao);
      setQuantidadeMinimaItens(selectedItem.quantidadeMinimaItens);
      setMessage(selectedItem.mensagem);
      setEmails(selectedItem.emails);
      setIdAnalise(selectedItem.idAnalise);
      setSelectedCOId(selectedItem.id);
      setSelectedMessage(null);
      setStatusCrud('patch');
      openModal();
    }
  };

  function handleAnalise(id: number) {
    let selectedAnalise = null;
    if (filterData !== null && filterData !== undefined && filterData.length > 0) {
      filterData.forEach((e) => {
        if (e.value === id) selectedAnalise = e;
      });
      if (selectedAnalise !== null && selectedAnalise !== undefined) setAnalise(selectedAnalise);
    }
  }

  const saveAll = () => {
    const model = {
      nome: nome,
      idAnalise: idAnalise,
      intervaloDiasExecucao: intervaloDias,
      quantidadeDiasUltimaCarga: quantidadeDiasUltimaCarga,
      percentualMinimoEstoqueCustoMedio: percentualMinimoEstoqueCustoMedio,
      percentualMinimoEstoqueReposicao: percentualMinimoEstoqueReposicao,
      valorMinimoCustoMedio: valorMinimoCustoMedio,
      valorMinimoReposicao: valorMinimoReposicao,
      quantidadeMinimaItens: quantidadeMinimaItens,
      mensagem: message,
      emails: emails,
      idEmpresa: selectedCompanyId,
    };

    if (statusCrud === 'post') postConsultorOnline(model);

    if (statusCrud === 'patch') patchConsultorOnline(model);
  };

  const postConsultorOnline = async (model: any) => {
    //Verificar pra pegar o status ok, mostrar mensagem na tela e limpar tela.
    const response = await new RestUseCase(`${ENDPOINT_CRUD}`).Post({ data: model }).finally();

    if (response.statusCode === 201 && response.statusCode !== undefined) {
      showAlert({ show: true, content: 'Cadastro realizado com sucesso', color: 'success', time: 5000 });
      clearField();
      findConsultantoOnline(selectedCompanyId);
    } else {
      showAlert({ show: true, content: 'Erro ao realizar o cadastro', color: 'danger', time: 5000 });
    }
  };

  const patchConsultorOnline = async (model: any) => {
    const url = ENDPOINT_CRUD + '/' + selectedCOId;
    const response = await new RestUseCase(`${url}`).Patch({ data: model }).finally();

    if (response.statusCode === 204 && response.statusCode !== undefined) {
      showAlert({ show: true, content: 'Cadastro alterado com sucesso', color: 'success', time: 5000 });
      clearField();
      findConsultantoOnline(selectedCompanyId);
    } else {
      showAlert({ show: true, content: 'Erro ao atualizar o cadastro', color: 'danger', time: 5000 });
    }
  };

  const ativarConsultorOnline = async () => {
    const url = ENDPOINT_CRUD + '/ativar/' + selectedCOId;
    const response = await new RestUseCase(`${url}`).Patch().finally();

    if (response.statusCode === 204 && response.statusCode !== undefined) {
      showAlert({ show: true, content: 'Consultor Online ativado com sucesso', color: 'success', time: 5000 });
      clearField();
      findConsultantoOnline(selectedCompanyId);
    } else {
      showAlert({ show: true, content: 'Erro ao ativar Consultor online', color: 'danger', time: 5000 });
    }
    closeModal();
  };

  const inativarConsultorOnline = async () => {
    const url = ENDPOINT_CRUD + '/inativar/' + selectedCOId;
    const response = await new RestUseCase(`${url}`).Patch().finally();

    if (response.statusCode === 204 && response.statusCode !== undefined) {
      showAlert({ show: true, content: 'Consultor Online inativado com sucesso', color: 'success', time: 5000 });
      clearField();
      findConsultantoOnline(selectedCompanyId);
    } else {
      showAlert({ show: true, content: 'Erro ao inativar Consultor online', color: 'danger', time: 5000 });
    }
    closeModal();
  };

  const deletarConsultorOnline = async () => {
    const url = ENDPOINT_CRUD + '/' + selectedCOId;
    const response = await new RestUseCase(`${url}`).Delete().finally();

    if (response.statusCode === 204 && response.statusCode !== undefined) {
      showAlert({ show: true, content: 'Consultor Online deletado com sucesso', color: 'success', time: 5000 });
      clearField();
      findConsultantoOnline(selectedCompanyId);
    } else {
      showAlert({ show: true, content: 'Erro ao deletar Consultor online', color: 'danger', time: 5000 });
    }
    closeModalConfirmDeletarCO();
  };

  function verificaEnvioEmail() {
    if (
      selectedCOId !== null &&
      selectedCOId !== undefined &&
      selectedUser !== null &&
      selectedUser !== undefined &&
      idAnalise !== null &&
      idAnalise !== undefined
    ) {
      openModalEnviarEmail();
    } else {
      showAlert({ show: true, content: 'Selecione um usuario e um planejamento!', color: 'danger', time: 5000 });
    }
  }

  const enviarEmailConsultorOnline = async (email: string) => {
    if (email !== null && email !== undefined && email !== '' && email.includes('@')) {
      showAlert({ show: true, content: 'Enviando e-mail Consultor Online', color: 'info', time: 5000 });
      closeModalEnviarEmail();
      const url = ENDPOINT_CRUD + '/testemail';
      const response = await new RestUseCase(`${url}`)
        .Put({
          data: {
            idUsuario: selectedUser?.value,
            idConsultorOnline: selectedCOId,
            idPlanejamento: idAnalise,
            email: email,
          },
        })
        .finally();

      if (response.statusCode === 204 && response.statusCode !== undefined) {
        showAlert({ show: true, content: 'E-mail Consultor Online enviado com sucesso', color: 'success', time: 5000 });
      } else {
        showAlert({ show: true, content: 'Erro ao enviar e-mail Consultor online', color: 'danger', time: 5000 });
      }
    } else {
      showAlert({ show: true, content: 'Verifique o endereço de e-mail que está passando', color: 'danger', time: 5000 });
    }
  };

  function clearField(): void {
    setNome('');
    setIntervaloDias(0);
    setQuantidadeDiasUltimaCarga(0);
    setPercentualMinimoEstoqueCustoMedio(0);
    setPercentualMinimoEstoqueReposicao(0);
    setValorMinimoCustoMedio(0);
    setValorMinimoReposicao(0);
    setQuantidadeMinimaItens(0);
    setMessage('');
    setEmails('');
    setIdAnalise(0);
    setSelectedCOId(0);
    setSelectedCOName('');
    setSelectedUser(null);
    setSelectedMessage(null);
    setAnalise(null);
    setStatusCrud('post');
  }

  // Função para abrir a modal
  const openModal = () => setShowModal(true);

  // Função para fechar a modal
  const closeModal = () => setShowModal(false);

  function novo(): void {
    if (selectedCompanyId === null) {
      showAlert({ show: true, content: 'Selecione uma empresa', color: 'warning', time: 5000 });
    } else {
      clearField();
      setShowConsultantActivation(false);
      openModal();
    }
  }

  const [stateChenged, setStateChenged] = useState('Initial State');

  const onChangeModalPlanning = (newState: any) => {
    setStateChenged(newState);
  };

  /**
   *
   *
   *
   *
   *  planejamento */
  const [showModalPlanning, updateShowModalPlanning] = useState(false);
  const [itemPlanning, updateItemPlanning] = useState<number>(0);
  const closePlanning = () => updateShowModalPlanning(false);
  const showPlanning = () => updateShowModalPlanning(true);

  useEffect(() => {
    const namePage = 'analytical';
    localStorage.setItem('actual_page', namePage);

    const local = getLocalStorage(LOCALSTORAGE_PLANNING);
    if (local !== null) {
      let countPlanning = local.length;
      updateItemPlanning(countPlanning);
    }
  }, []);

  useEffect(() => {
    setSelectedUser(null);
    getFilterAnalyticalByCompany();
  }, [selectedCompanyId]);

  useEffect(() => {
    getFilterAnalyticalByCompany();
  }, [stateChenged]);

  useEffect(() => {
    handleAnalise(idAnalise);
  }, [idAnalise]);

  async function handleApplyPlanning(model: any) {
    /** inicia o loading */
    updateLoading(true);
    /** fecha o modal */
    closePlanning();
    let countPlanning = model.length;
    /** salva no localstorage */
    updateLocalStorege(LOCALSTORAGE_PLANNING, model);
  }

  function ModalEnviarEmail() {
    const emailRef = useRef<HTMLInputElement>(null);

    const handleEnviarEmail = () => {
      const email = emailRef.current?.value || '';
      enviarEmailConsultorOnline(email);
    };

    return (
      <Modal show={showModalEnviarEmail} onHide={closeModalEnviarEmail} size={'lg'} centered={true}>
        <Modal.Header closeButton>
          <Modal.Title className="ms-3 lead" style={{ fontSize: '30px' }}>
            Enviar Email
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Row className="mt-3">
              <Col>E-mail:</Col>
            </Row>
            <Col>
              <Form.Control type="text" placeholder="E-mail" maxLength={1000} ref={emailRef} />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleEnviarEmail}>
            Enviar
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  function ModalPlanning() {
    return (
      <Modal show={showModalPlanning} onHide={closePlanning} size={'xl'} fullscreen={true}>
        <Modal.Header closeButton>
          <Modal.Title className="ms-3 lead" style={{ fontSize: '30px' }}>
            Planejamento
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
              <ContainerFilter
                keyLocalStorage={LOCALSTORAGE_PLANNING}
                filterLocalStorage={getLocalStorage(LOCALSTORAGE_PLANNING)}
                apply={handleApplyPlanning}
                filtersDefault={optionsFiltersDefault}
                listAllPlanning={(params) => {
                  params.idUsuario = selectedUser?.value;
                  return listAllPlanning(params);
                }}
                listByIdPlanning={function (params?: any): Promise<any> {
                  throw new Error('listByIdPlanning ==> não foi implementada');
                }}
                createPlanning={(params) => {
                  params.idEmpresa = selectedCompanyId;
                  params.idUsuario = selectedUser?.value;
                  return createPlanning(params);
                }}
                editPlanning={(params) => {
                  params!.model.idEmpresa = selectedCompanyId;
                  params!.model.idUsuario = selectedUser?.value;
                  return editPlanning(params);
                }}
                removePlanning={(params) => {
                  params.idUsuario = selectedUser?.value;
                  return removePlanning(params);
                }}
                isOnlineConsultant={true}
                onChangeModalPlanning={onChangeModalPlanning}
              />
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    );
  }

  return (
    <>
      {loading && <Loading />}
      <div className="mx-3">
        <TitleGroupComponent titlePage={titlePage}>
          <Row></Row>
        </TitleGroupComponent>
        <SelectCompany
          onCompanyChange={(companyId: string | null) => {
            setSelectedCompanyId(companyId);
            onSelectedCompanyChange?.(companyId);
            if (companyId) {
              findConsultantoOnline(companyId);
              getUsersByCompany(companyId);
              // getFilterAnalyticalByCompany(companyId);
            }
          }}
          onNewButtonClick={novo}
        />
      </div>

      {/* Body - Tabela */}
      <div className="mx-3">
        <Card style={{ height: '400px', marginTop: '10px' }}>
          <CardBody>
            <Row>
              <h3>Ativos</h3>
            </Row>
            <Row style={{ marginTop: '10px', borderBottom: '1px solid #6C757D' }}></Row>
            {tabBodyConsultantActive}
          </CardBody>
        </Card>

        <Card style={{ height: '400px', marginTop: '10px' }}>
          <CardBody>
            <Row>
              <h3>Inativos</h3>
            </Row>
            <Row style={{ marginTop: '10px', borderBottom: '1px solid #6C757D' }}></Row>
            <div>{tabBodyConsultantInactive}</div>
          </CardBody>
        </Card>
      </div>

      {/* Modal */}
      <Modal show={showModal} onHide={closeModal} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>{titlePage}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mx-3">
            <form className="mt-0" noValidate>
              {showConsultantActivation ? (
                <Row className="mt-3">
                  <Col>
                    {isConsultantInactive ? (
                      <Button variant="success" className="d-flex align-items-center" onClick={ativarConsultorOnline} size="sm">
                        Ativar Consultor Online
                      </Button>
                    ) : (
                      <Button variant="danger" className="d-flex align-items-center" onClick={inativarConsultorOnline} size="sm">
                        Inativar Consultor Online
                      </Button>
                    )}
                  </Col>
                </Row>
              ) : (
                <></>
              )}
              <Row className="mt-3">
                <Col>Nome:</Col>
                <Col>Usuário:</Col>
                <Col>
                  Planejamento:
                  <div style={{ float: 'right' }}>
                    <Button
                      variant="outline-primary"
                      className="d-flex align-items-center"
                      onClick={showPlanning}
                      size="sm"
                      disabled={selectedUser === null || selectedUser === undefined}
                    >
                      Novo Planejamento
                    </Button>
                  </div>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col>
                  <Form.Control type="text" placeholder="Nome" maxLength={50} value={nome} onChange={handleChangeNome} />
                </Col>
                <Col>
                  <Select
                    id="combo-usuario"
                    options={usersList}
                    value={selectedUser}
                    onChange={handleUserSelection}
                    placeholder="Selecione um usuário"
                  />
                </Col>
                <Col>
                  <Select
                    id="combo-analise"
                    options={filterData}
                    value={analise}
                    onChange={handleChangeAnalise}
                    placeholder="Selecione um planejamento"
                  />
                </Col>
              </Row>
              <Row className="mt-3">
                <Col>Intervalo Dias Execução:</Col>
                <Col>Quantidade de Dias Última Carga:</Col>
                <Col>Percentual Mínimo de Estoque Custo Médio:</Col>
              </Row>
              <Row className="mt-3">
                <Col>
                  <Form.Control type="number" placeholder="Intervalo Dias Execução" value={intervaloDias} onChange={handleChangeIntervaloDias} min={0} />
                </Col>
                <Col>
                  <Form.Control
                    type="number"
                    placeholder="Quantidade de Dias Última Carga"
                    value={quantidadeDiasUltimaCarga}
                    onChange={handleChangeQuantidadeDiasUltimaCarga}
                    min={0}
                  />
                </Col>
                <Col>
                  <Form.Control
                    type="number"
                    placeholder="Percentual Mínimo de Estoque Custo Médio"
                    value={percentualMinimoEstoqueCustoMedio}
                    onChange={handleChangePercentualMinimoEstoqueCustoMedio}
                    min={0}
                  />
                </Col>
              </Row>
              <Row className="mt-3">
                <Col>Percentual Mínimo Estoque Reposição:</Col>
                <Col>Valor Mínimo Custo Médio:</Col>
                <Col></Col>
              </Row>
              <Row className="mt-3">
                <Col>
                  <Form.Control
                    type="number"
                    placeholder="Percentual Mínimo Estoque Reposição"
                    value={percentualMinimoEstoqueReposicao}
                    onChange={handleChangePercentualMinimoEstoqueReposicao}
                    min={0}
                  />
                </Col>
                <Col>
                  <Form.Control
                    type="number"
                    placeholder="Valor Mínimo Custo Médio"
                    value={valorMinimoCustoMedio}
                    onChange={handleChangeValorMinimoCustoMedio}
                    min={0}
                  />
                </Col>
                <Col></Col>
              </Row>
              <Row className="mt-3">
                <Col>Valor Mínimo Custo Médio:</Col>
                <Col>Valor Mínimo Reposição:</Col>
                <Col>Quantidade Mínima Itens:</Col>
              </Row>
              <Row className="mt-3">
                <Col>
                  <Form.Control
                    type="number"
                    placeholder="Valor Mínimo Custo Médio"
                    value={valorMinimoCustoMedio}
                    onChange={handleChangeValorMinimoCustoMedio}
                    min={0}
                  />
                </Col>
                <Col>
                  <Form.Control
                    type="number"
                    placeholder="Valor Mínimo Reposição"
                    value={valorMinimoReposicao}
                    onChange={handleChangeValorMinimoReposicao}
                    min={0}
                  />
                </Col>
                <Col>
                  <Form.Control
                    type="number"
                    placeholder="Quantidade Mínima Itens"
                    value={quantidadeMinimaItens}
                    onChange={handleChangeQuantidadeMinimaItens}
                    min={0}
                  />
                </Col>
              </Row>
              <Row className="mt-3">
                <Col>Emails (serparado por vírgula, ponte-e-vírgula ou espaço):</Col>
              </Row>
              <Row>
                <Col>
                  <Form.Control type="text" placeholder="Emails" maxLength={10000} value={emails} onChange={handleChangeEmails} />
                </Col>
              </Row>
              <Row className="mt-1">
                <Col>Modelo de Mensagens de Regras já Cadastradas:</Col>
              </Row>
              <Row className="mt-1">
                <Col>
                  <Select
                    isDisabled={messageModelActive.concat(messageModelInactive).length === 0}
                    options={messageModelActive.concat(messageModelInactive).map((e) => ({ label: e.nome, value: e.id }))}
                    value={selectedMessage}
                    onChange={handleChangeModelo}
                    placeholder="Selecione um modelo"
                  />
                </Col>
              </Row>
              <Row className="mt-1">
                <Col>
                  Mensagem:
                  <div style={{ display: 'ruby' }}>
                    {variablesList.map((variable, index) => {
                      return (
                        <>
                          <Button
                            className="d-flex align-items-center"
                            variant="outline-primary"
                            onClick={() => {
                              navigator.clipboard.writeText(variable.value);
                            }}
                            data-for="copyButton"
                            data-tip="copiado!"
                            data-event="click focus"
                            style={{ fontSize: 'small', margin: '1px 2px' }}
                          >
                            {variable.value}
                            <ReactTooltip id="copyButton" backgroundColor={'#017BFE'} border delayHide={1000} isCapture={true} />
                          </Button>
                        </>
                      );
                    })}
                  </div>
                </Col>
              </Row>
              <Row className="mt-1">
                <Col>
                  <JoditEditor ref={editorRef} value={message} onBlur={(event) => handleChangeMessage(event)} />
                </Col>
              </Row>
            </form>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between">
          <div>
            {statusCrud === 'patch' && (
              <Button variant="primary" onClick={verificaEnvioEmail}>
                Enviar E-mail
              </Button>
            )}
          </div>
          <div>
            <Button variant="secondary" onClick={closeModal} style={{ marginRight: '5px' }}>
              Fechar
            </Button>
            <Button
              style={{ marginRight: '5px' }}
              variant="primary"
              onClick={() => {
                saveAll();
                closeModal();
              }}
              disabled={analise === null || analise === undefined}
            >
              Salvar
            </Button>
            <Button variant="outline-primary" onClick={clearField}>
              Limpar
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      <ModalPlanning />
      <ModalEnviarEmail />
      <ModalConfirmAction
        confirmActionFunction={deletarConsultorOnline}
        confirmButtonMessage="Deletar"
        closeButtonMessage="Cancelar"
        closeModalConfirmAction={closeModalConfirmDeletarCO}
        message={`Realmente deseja deletar o consultor online: ${selectedCOName}`}
        showModalConfirmAction={showModalConfirmDeletarCO}
        titleConfirmAction="Deletar Consultor Online"
      />
    </>
  );
};

export default RegraConsultorOnlinePage;
